import React from 'react'

const QuestionMark = ({ height, width, fillColor }) => (
  <svg
    width={width || '15'}
    height={height || '25'}
    viewBox="0 0 15 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.56977 16.9946V15.8752C4.56977 14.6992 4.7907 13.7155 5.23256 12.924C5.69767 12.1325 6.51163 11.2958 7.67442 10.4138C8.83721 9.5545 9.65116 8.84215 10.1163 8.2768C10.6047 7.71144 10.8488 7.0104 10.8488 6.17368C10.8488 5.31434 10.5349 4.65853 9.90698 4.20624C9.30233 3.75396 8.43023 3.52782 7.2907 3.52782C6.26744 3.52782 5.2907 3.67481 4.36047 3.96879C3.43023 4.26278 2.5 4.63591 1.56977 5.0882L0 1.89959C1.06977 1.33424 2.23256 0.881955 3.48837 0.542742C4.74419 0.180914 6.12791 0 7.63953 0C9.98837 0 11.8023 0.554048 13.0814 1.66214C14.3605 2.74763 15 4.18363 15 5.97015C15 6.94256 14.8372 7.77929 14.5116 8.48033C14.2093 9.15875 13.7442 9.79195 13.1163 10.3799C12.5116 10.9679 11.7791 11.5898 10.9186 12.2456C10.1977 12.7883 9.65116 13.2519 9.27907 13.6364C8.90698 14.0208 8.65116 14.4052 8.51163 14.7897C8.37209 15.1515 8.30233 15.6038 8.30233 16.1465V16.9946H4.56977ZM3.90698 22.3881C3.90698 21.4383 4.16279 20.7711 4.67442 20.3867C5.2093 19.9796 5.84884 19.7761 6.59302 19.7761C7.31395 19.7761 7.93023 19.9796 8.44186 20.3867C8.97674 20.7711 9.24419 21.4383 9.24419 22.3881C9.24419 23.3152 8.97674 23.9824 8.44186 24.3894C7.93023 24.7965 7.31395 25 6.59302 25C5.84884 25 5.2093 24.7965 4.67442 24.3894C4.16279 23.9824 3.90698 23.3152 3.90698 22.3881Z"
      fill={fillColor || 'white'}
    />
  </svg>
)

export default QuestionMark
